export enum ServiceSubStep {
    ServiceCentreSelection = 'SERVICE_CENTRE_SELECTION',
    DeliveryServiceSelection = 'DELIVERY_SERVICE_SELECTION',
    SpecificServiceSelection = 'SPECIFIC_SERVICE_SELECTION',
}
